import {
  AfterContentInit,
  Component,
  ContentChildren,
  Input,
  OnDestroy,
  QueryList,
  ChangeDetectionStrategy,
} from '@angular/core';
import { Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';
import { PanelComponent } from '../panel/panel.component';

enum InitialState {
  // Collapse all panels on init
  Collapsed = 'collapsed',
  // Expand all panels on init
  Expanded = 'expanded',
  // Don't alter the state of children panels on initialization
  Unchanged = 'unchanged',
}

@Component({
  selector: 'atlas-accordion',
  templateUrl: './accordion.component.html',
  styleUrls: ['./accordion.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class AccordionComponent implements AfterContentInit, OnDestroy {
  @ContentChildren(PanelComponent) panels: QueryList<PanelComponent>;
  @Input() initialState: InitialState = InitialState.Unchanged;

  private _destroyed$$: Subject<void> = new Subject<void>();

  ngAfterContentInit(): void {
    this.initializeChildPanels();
    this.listenForPanelExpansions();
  }

  initializeChildPanels(): void {
    switch (this.initialState) {
      case InitialState.Expanded:
        this.panels.forEach((p) => (p.collapsed = false));
        break;
      case InitialState.Collapsed:
        this.panels.forEach((p) => (p.collapsed = true));
        break;
      case InitialState.Unchanged:
        break;
    }
  }

  listenForPanelExpansions(): void {
    this.panels.forEach((panel) => {
      panel.collapsed$
        .pipe(
          takeUntil(this._destroyed$$),
          filter((isCollapsed) => !isCollapsed),
        )
        .subscribe(() => this.selectPanel(panel));
    });
  }

  selectPanel(panel: PanelComponent): void {
    // close all panels other than the selected one.
    this.panels
      .filter((p) => p !== panel)
      .forEach((p) => {
        p.collapsed = true;
      });
  }

  ngOnDestroy(): void {
    this._destroyed$$.next();
    this._destroyed$$.complete();
  }
}
